import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { normalizationService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseGetMerchantsChangesMutationProps = {
	paidMonth: Date | string;
	paidYear: Date | string;
	page?: number;
	showSpinner?: boolean;
};

const useGetMerchantsChangesMutation = ({
	paidMonth,
	paidYear,
	showSpinner = false,
}: UseGetMerchantsChangesMutationProps) => {
	const dispatch = useDispatch();

	return useMutation(
		({ page = 0 }: { page?: number }) => {
			showSpinner && dispatch(uiActions.showSpinnerOverlay());

			return normalizationService.getMerchantsChanges({
				paidMonth,
				paidYear,
				page,
			});
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess() {},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useGetMerchantsChangesMutation;
